
import React, { useCallback, useMemo, useContext } from 'react';
import { SELECT_TAB } from '../../actions';
import { useStore } from '../../hooks';
import TabItem from './TabItem';
import { AVAILABLE_TABS } from './Tabs.constants';
import { StyledTabs } from './Tabs.styled';
import { EditorContext } from '../../../../index';

const Tabs = () => {
  const { t, dispatch, tabId = null, config: { tabsIds, useCloudimage } } = useStore();
  const { setCurrentTab } = useContext(EditorContext);
  const activeTabId = tabId ?? null;

  const chosenTabs = useMemo(() => {
    let tabs = [];
    if (tabsIds?.length > 0) {
      AVAILABLE_TABS.forEach((tab) => {
        const index = tabsIds.indexOf(tab.id);
        if (index !== -1) {
          tabs[index] = tab;
        }
      });
    } else {
      tabs = AVAILABLE_TABS;
    }

    return (tabs.length > 0 ? tabs : AVAILABLE_TABS).filter(
      ({ hideFn }) => !hideFn || !hideFn({ useCloudimage }),
    );
  }, [tabsIds, useCloudimage]);

  const deselectTab = useCallback(() => {
    setCurrentTab(null);
    dispatch({
      type: SELECT_TAB,
      payload: { tabId: null },
    });
  }, [dispatch, setCurrentTab]);

  const handleSelectTab = useCallback(
    (newTabId) => {
      if (newTabId === activeTabId) {
        deselectTab();
        return;
      }

      setCurrentTab(newTabId);
      dispatch({
        type: SELECT_TAB,
        payload: {
          tabId: newTabId,
        },
      });
    },
    [activeTabId, deselectTab, dispatch, setCurrentTab],
  );

  // If only 1 tab is needed then no need to have the tabs sidebar.
  if (chosenTabs.length === 1) {
    return null;
  }

  return (
    <div
      className="respark_tabs-rail"
      role="presentation"
      onClick={deselectTab}
      onKeyDown={undefined}
    >
      <StyledTabs
        className="respark_tabs"
        role="tablist"
        aria-label={t('sidebarTabsLabel') || 'Editor tabs'}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
      >
        {chosenTabs.map(({ id, labelKey, icon }) => (
          <TabItem
            key={id}
            id={id}
            label={t(labelKey)}
            Icon={icon}
            isSelected={activeTabId === id}
            onClick={handleSelectTab}
          />
        ))}
      </StyledTabs>
    </div>
  );
};

export default Tabs;
